module.exports = __webpack_public_path__ + "img/list.8643d146.png";